export default __webpack_public_path__ + "wp-content/uploads/react/user-dashboard/media/logoDOLCESALATO.d0648731.svg";